(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenuFit extends HTMLElement {
    connectedCallback() {
      this.header = this.previousElementSibling;
      this.nav = this.header.querySelector('.header__inline-menu');
      this.list = this.nav?.querySelector('.list-menu--inline');
      this.drawer = this.header.querySelector('header-drawer');
      this.logo = this.header.querySelector('.header__heading-link');
      this.icons = this.header.querySelector('.header__icons');
      if (!this.list || !this.drawer || !this.logo || !this.icons) return;

      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.resizeObserver = new ResizeObserver(this.schedule);
      [this.header, this.list, this.logo, this.icons].forEach((element) => this.resizeObserver.observe(element));
      this.mutationObserver = new MutationObserver(this.schedule);
      this.mutationObserver.observe(this.list, { subtree: true, childList: true, characterData: true });
      window.addEventListener('resize', this.schedule);
      document.fonts.addEventListener('loadingdone', this.schedule);
      this.schedule();
    }

    update() {
      const style = getComputedStyle(this.header);
      const available = this.header.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const menuWidth = this.list.getBoundingClientRect().width;
      const stacked = this.header.matches('.header--top-left, .header--top-center');
      const required = stacked ? menuWidth : menuWidth + this.logo.getBoundingClientRect().width +
        this.icons.getBoundingClientRect().width - this.drawer.getBoundingClientRect().width +
        (parseFloat(style.columnGap) || 0) * 2;
      const overflow = window.matchMedia('(min-width: 1100px)').matches && required > available;
      if (overflow === this.header.classList.contains('header--menu-overflow')) return;
      const moveFocusToDrawer = overflow && this.nav.contains(document.activeElement);

      if (overflow) {
        this.nav.querySelectorAll('header-menu').forEach((menu) => menu.close?.());
      } else if (this.drawer.querySelector('details[open]')) {
        this.drawer.closeMenuDrawer(null, this.drawer.querySelector('summary'));
        this.logo.focus();
      }
      this.nav.inert = overflow;
      this.header.classList.toggle('header--menu-overflow', overflow);
      if (moveFocusToDrawer) this.drawer.querySelector('summary').focus();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      if (this.schedule) {
        window.removeEventListener('resize', this.schedule);
        document.fonts.removeEventListener('loadingdone', this.schedule);
      }
    }
  }

  customElements.define('header-menu-fit', HeaderMenuFit);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      // 검색 모달이 열려있으면 헤더를 숨기지 않음
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && this.searchModal.isOpen()) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
